
function Recommandations() { // show the list of Cards "realisation" depending on the filter chosen


    return (

        <section className="recommandations" id="recommandations">
            <div className="recommandations-content">
                <blockquote cite="https://www.lehibou.com/freelance/3b29d051-1238-4d94-b158-9bb68a31b663">"Manuel fait partie des professionnels vielle école. Rigoureux mais approchable, avec un sens des responsabilités comme on n'en fait plus.
                Son parcours professionnel s'étend sur plus de 20 ans et est riche d'expériences dans plusieurs domaines.<br />

                Rien ne reste un problème longtemps avec Manuel. Il voit, perçoit, trouve et résoud les problèmes avant que vous sachiez qu'il y en avait un!
               <br />

                Pour sûr, vous lui confierez un deuxième projet et le recommanderez à vos amis entrepreneurs."
</blockquote>
                <p>Georges Brisset <span>- Mentor OpenClassrooms </span> </p>
            </div>


        </section>
    );
}

export default Recommandations;